import styled from 'styled-components';
export var MapContent = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-kf1k4i-0"
})(["position:relative;width:100%;height:100%;overflow:hidden;border-radius:6px;box-shadow:0px 10px 20px 0px rgba(0,0,0,0.05);.mapboxgl-ctrl-logo{display:none;}.mapbox__marker{background-image:url(", "/images/offer-marker.svg);width:70px;height:43px;}.mapbox__marker__tooltip{top:23px;width:250px;border-radius:8px;padding:", ";padding-top:", ";background-color:", ";color:", ";opacity:0.7;font-family:IntervalNextReg,sans-serif;font-size:", ";line-height:", ";text-align:center;}", " ", ""], process.env.CDN_URL, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(4);
}, function (props) {
  return props.theme.colors.shuttleGray;
}, function (props) {
  return props.theme.colors.lightest;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.withoutControls && '.mapboxgl-ctrl { display: none; } ';
}, function (props) {
  return props.locked && "\n      .mapboxgl-ctrl {\n        display: none;\n      }\n\n      & > div {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n  ";
});